export const mPosthogPublicApiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY || "phc_BxJRSk2LkBdjaNXX801rJlQ5n4K86LjlTWQMejbT6sz";
export const mPosthogPublicHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST || "https://ph.trybacon.ai";
export const mPosthogUIHost = import.meta.env.VITE_PUBLIC_POSTHOG_UI_HOST || "https://us.i.posthog.com";
